// app/src/screens/MyContent.jsx — the library (handoff §7), pixel-close. CREATE-2: REAL now —
// the grid renders the owner's REAL runs (GET /v1/runs) as video cards → Result. No fixtures.
// Series is an honest coming-soon (the entity rides the remix work later — CREATE-1 §11); the
// Series tab shows a clean empty state, never fake series. Every string via t().

import React, { useEffect, useState } from 'react';
import { Plus, Layers } from 'lucide-react';
import { navigate } from '@common/router.js';
import { useI18n } from '../i18n/index.jsx';
import { useSession } from '../lib/session.jsx';
import { useIsMobile } from '../lib/useIsMobile.js';

const RUN_GRADIENTS = ['var(--poster-coral)', 'var(--poster-violet)', 'var(--poster-amber)', 'var(--poster-teal)', 'var(--poster-mint-flat)'];

function Card({ run, gradient, onClick, t }) {
  return (
    <button className="q-btn qcard lift" onClick={onClick} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 18, overflow: 'hidden', textAlign: 'start', padding: 0 }}>
      <div style={{ height: 138, background: gradient, margin: '4px 4px 0', borderRadius: 14 }} />
      <div style={{ padding: '12px 14px' }}>
        <div style={{ font: '700 14px var(--font-body)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{run.title || run.run_id}</div>
        <div style={{ font: '400 11px var(--font-mono)', color: 'var(--text-faint)', marginTop: 2 }}>{run.updated_at ? new Date(run.updated_at).toLocaleDateString() : (run.mode || t('content.run'))}</div>
      </div>
    </button>
  );
}

export default function MyContent() {
  const { t } = useI18n();
  const { api } = useSession();
  const mobile = useIsMobile();
  const [runs, setRuns] = useState(null);
  const [tab, setTab] = useState('all');

  useEffect(() => { api.get('runs').then((r) => setRuns(r.kind === 'ok' ? (r.body.runs || []) : [])); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!runs) return <div className="view"><p className="muted">{t('common.loading')}</p></div>;

  const TABS = [['all', 'content.all'], ['videos', 'content.videos'], ['series', 'content.series']];
  const showSeries = tab === 'series';
  const showVideos = tab === 'all' || tab === 'videos';

  return (
    <div className="view">
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 className="h-page" style={{ marginBottom: 4 }}>{t('content.title')}</h1>
          {!mobile && <p className="muted" style={{ margin: 0, fontSize: 14 }}>{t('content.subtitle')}</p>}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {TABS.map(([k, key]) => (
          <button key={k} className="q-btn" onClick={() => setTab(k)} style={{ padding: '8px 16px', borderRadius: 999, background: tab === k ? 'var(--ink)' : 'var(--surface)', color: tab === k ? '#fff' : 'var(--text-muted)', border: tab === k ? 'none' : '1px solid var(--border)', font: `${tab === k ? 700 : 600} 12.5px var(--font-body)` }}>{t(key)}</button>
        ))}
      </div>

      {showSeries && (
        <div style={{ textAlign: 'center', padding: '56px 20px' }}>
          <div style={{ width: 56, height: 56, borderRadius: 999, background: 'var(--violet-tint)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}><Layers size={26} color="var(--violet)" strokeWidth={1.9} /></div>
          <h3 className="h-card" style={{ margin: '0 0 8px' }}>{t('content.seriesSoonTitle')}</h3>
          <p className="muted" style={{ fontSize: 14, maxWidth: 420, margin: '0 auto' }}>{t('content.seriesSoonNote')}</p>
        </div>
      )}

      {showVideos && (
        runs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '56px 20px' }}>
            <p className="muted" style={{ fontSize: 15, margin: '0 0 18px' }}>{t('content.empty')}</p>
            <button className="q-btn press btn-primary" onClick={() => navigate('/')}>{t('content.makeFirst')} →</button>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: mobile ? '1fr 1fr' : 'repeat(auto-fit,minmax(206px,1fr))', gap: mobile ? 12 : 16 }}>
            {runs.map((r, i) => <Card key={r.run_id} run={r} gradient={RUN_GRADIENTS[i % RUN_GRADIENTS.length]} onClick={() => navigate(`/result/${encodeURIComponent(r.run_id)}`)} t={t} />)}
            <button className="q-btn" onClick={() => navigate('/')} style={{ border: '1.5px dashed var(--chevron)', background: 'var(--paper)', borderRadius: 18, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 9, minHeight: 186, color: 'var(--text-faint)', font: '700 13px var(--font-body)' }}>
              <span style={{ width: 40, height: 40, borderRadius: 999, background: 'var(--surface)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Plus size={18} color="var(--coral)" strokeWidth={2.2} /></span>
              {t('content.newContent')}
            </button>
          </div>
        )
      )}
    </div>
  );
}
